import { useQuery } from 'react-query'
import { Auth } from 'types'
import { MentionUser } from '../../../api/clients/MentionClient'
import { WorkspaceClient } from '../../../api/clients/WorkspaceClient'
import { handleErrorResponseWithMessage } from '../../../api/utils/handleErrorResponseWithMessage'
import { ObjectsToLoad } from '../MentionPrompt/MentionPrompt'

interface Props {
  auth: Auth | null
  query: string
  objectsToLoad: ObjectsToLoad[]
}

export const useUsers = ({ auth, query, objectsToLoad }: Props) => {
  return useQuery<MentionUser[]>(
    [
      'mention-prompt',
      'users',
      {
        query,
        company_id: auth?.company_id,
      },
    ],
    async () => {
      if (!auth) {
        return []
      }

      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const response = await WorkspaceClient.getUsers(auth!.company_id, query, 3).then(handleErrorResponseWithMessage())

      if (response && response.type === 'success') {
        const {
          data: { users },
        } = response

        return users
      } else {
        throw new Error()
      }
    },
    {
      enabled: objectsToLoad.includes(ObjectsToLoad.Users),
      placeholderData: [],
      staleTime: 1000 * 60, // 1 minute
    },
  )
}
